@if (showTypePicker()) {
    <div class="mode-selection-container">
        @for(type of itemTypes; track type.value) {
            <div class="mode-card" (click)="selectItemType(type.value)">
                <i [class]="type.icon"></i>
                <h3>{{type.label}}</h3>
                <p>{{type.desc}}</p>
            </div>
        }
    </div>
    <div class="flex justify-content-center mt-4">
        <p-button icon="pi pi-arrow-left" [text]="true" label="Regresar" (click)="showTypePicker.set(false)" severity="secondary"></p-button>
    </div>
} @else {
    <div class="mx-4 mt-4">
        <div class="page-header" id="tour-inv-header">
            <div class="flex justify-content-between align-items-center mb-3">
                <h2 class="m-0">Gestión de Inventario</h2>
                <div class="flex gap-2 align-items-center">
                    @if (userBranches().length > 1) {
                        <p-dropdown [options]="userBranches()" [ngModel]="selectedBranchId()" (ngModelChange)="selectedBranchId.set($event)" optionLabel="name" optionValue="id" styleClass="w-full"></p-dropdown>
                    }
                    @if (canManageInventory) {
                        <p-button icon="pi pi-file-excel" label="Importar Datos" (onClick)="goToBulkImport()" severity="success" [rounded]="true"></p-button>
                    }
                    <p-button icon="pi pi-bolt" label="Acciones Rápidas" (onClick)="quickActions.show()" severity="warn" [rounded]="true" id="tour-inv-quick"></p-button>
                    <p-button icon="pi pi-question-circle" label="Ayuda" (onClick)="openGuide()" severity="info" [text]="true" id="tour-inv-help"></p-button>
                </div>
            </div>
            <div class="subtitle-container">
                <p class="page-subtitle m-0">Administre los artículos, movimientos y maestros del sistema.</p>
            </div>
        </div>

        <!-- Componente de Acciones Rápidas -->
        <app-quick-actions #quickActions (onMovementSuccess)="onQuickMovementSuccess()" [branchId]="selectedBranchId()" [userBranches]="userBranches()"></app-quick-actions>

        <div class="flex gap-2 my-4" id="tour-inv-tabs">
            @for(type of types(); track type.value) {
                <p-button
                    [label]="type.label"
                    [outlined]="selectedType() !== type.value"
                    (onClick)="setType(type.value)"
                    size="small">
                </p-button>
            }
        </div>

        @if (selectedType() === 'items') {
                <app-table-items [selectedCategory]="pendingType()" [refreshTrigger]="refreshTrigger()" [branchId]="selectedBranchId()" (onNewClicked)="handleNewRequest()"></app-table-items>
            } @else if (selectedType() === 'stock-movements') {
                <app-table-stock-movements [refreshTrigger]="refreshTrigger()" [branchId]="selectedBranchId()"></app-table-stock-movements>
            } @else if (selectedType() === 'stock-transfers') {
                <app-table-stock-transfers [refreshTrigger]="refreshTrigger()" [branchId]="selectedBranchId()"></app-table-stock-transfers>
            } @else {
                <app-table-inventory [type]="selectedType()"></app-table-inventory>
            }
    </div>
}
